(function () {
  setInterval(function () {
    const url = window.location.href;
    const params = new URLSearchParams(window.location.search);
    // Layout filter
    const keywords = ['LANDSCAPE', 'LANDSCAPE+-+WIDE', 'PORTRAIT', 'PORTRAIT+-+TALL', 'SQUARE'];
    const pieceMatched = keywords.some(function (k) { return url.includes(k); });
    document.body.classList.toggle('show-clear-btn', pieceMatched);
    // Width filter
    const widthMatched = params.has('pf_rs2_width');
    document.body.classList.toggle('show-width-clear-btn', widthMatched);
    // Height filter
    const heightMatched = params.has('pf_rs3_height');
    document.body.classList.toggle('show-height-clear-btn', heightMatched);
    const keywords2 = ['pf_opt_size', '15'];
    const pieceMatched2 = keywords2.some(function (k) { 
      return url.includes(k); 
    });
    document.body.classList.toggle('show-clear-btn2', pieceMatched2);
  }, 300); 
})();